import Device from './device';
import { normalize, schema } from 'normalizr';
import { exists } from '../../util/util';

class DeviceConverter {
  
  fromAPIDevicesResponse(devicesResp) {
    
    const localDevices = devicesResp.map(device => {
      return this.fromAPIDevice(device);
    });

    const devicesEntity = new schema.Entity('devices');
    const deviceSchema = [devicesEntity];
    const normalizedData = normalize(localDevices, deviceSchema);

    console.info('[DeviceConverter.fromAPIDevice] converted devices: ', normalizedData.entities.devices);

    return normalizedData.entities.devices;
  }
  
  fromAPIDevice(response) {
    
    let params = {};
    params.id = response.id;
    params.dateRegistered = response.dateRegistered;
    params.dateActivated = response.dateActivated;
    params.macAddress = response.macAddress;
    params.serialNumber = response.serialNumber;
    params.owner = response.owner;
    params.description = response.description;
    params.lastLog = response.lastLog;
    
    if(response.activeStatus) {
      params.activeStatus = response.activeStatus;
      
      if(exists(response.activeStatus.id)) params.activeStatusId = response.activeStatus.id;
      if(response.activeStatus.title) params.activeStatusTitle = response.activeStatus.title;
    }
    
    if(response.presenceStatus) {
      params.presenceStatus = response.presenceStatus;
      
      if(exists(response.presenceStatus.id)) params.presenceStatusId = response.presenceStatus.id;
      if(response.presenceStatus.title) params.presenceStatusTitle = response.presenceStatus.title;
    }
    
    if(response.drynessStatus) {
      params.drynessStatus = response.drynessStatus;
      
      if(exists(response.drynessStatus.id)) params.drynessStatusId = response.drynessStatus.id;
      if(response.drynessStatus.title) params.drynessStatusTitle = response.drynessStatus.title;
    }
    
    if(response.lastLog) {
      if(response.lastLog.time) {
        params.lastLogTime = response.lastLog.time;
      }
    }
  
    if(response.noOfWetStatuses) {
      params.noOfWetStatuses = response.noOfWetStatuses;
    }
    
    return new Device(params);
  }
  
  toAPIDevice(response) {
    
    let params = {};
    params.id = response.id;
    params.dateRegistered = response.dateRegistered;
    params.dateActivated = response.dateActivated;
    params.macAddress = response.macAddress;
    params.serialNumber = response.serialNumber;
    params.activeStatus = response.activeStatus;
    params.presenceStatus = response.presenceStatus;
    params.drynessStatus = response.drynessStatus;
    params.owner = response.owner;
    params.description = response.description;
    params.lastLog = response.lastLog;
    
    return { ...params };
  }
}

export default new DeviceConverter();


// WEBPACK FOOTER //
// ./src/models/device/deviceConverter.js